import { render, staticRenderFns } from "./mainTaskStay.vue?vue&type=template&id=2fe5f296&"
import script from "./mainTaskStay.vue?vue&type=script&lang=js&"
export * from "./mainTaskStay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fe5f296')) {
      api.createRecord('2fe5f296', component.options)
    } else {
      api.reload('2fe5f296', component.options)
    }
    module.hot.accept("./mainTaskStay.vue?vue&type=template&id=2fe5f296&", function () {
      api.rerender('2fe5f296', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameData/actionAnalysis/mainTaskStay.vue"
export default component.exports